module.exports = __webpack_public_path__ + "img/home-high-3.97626c60.png";